import styled from '@emotion/styled';
import { useAuth } from '@teamexos/fit-shared';
import ErrorComponent from 'components/Error';
import useMixpanel from 'hooks/useMixpanel';
import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import { useLocation, useNavigate } from 'react-router';

export const QR_REDIRECT_PATH = '/qr_redirect';

const ErrorWrapper = styled.main({
  margin: '0 auto',
});

const RedirectQR: React.FC = () => {
  const navigate = useNavigate();
  const track = useMixpanel();
  const location = useLocation();

  const { isLoggedIn } = useAuth();

  const continueMessage = isLoggedIn
    ? 'Continue to Home'
    : 'Continue to Login Anyway';

  // if it comes from /qr_redirect/* we need to remove the /qr_redirect from the path
  // so we can pass the correct path to the QR code
  const locationPath = location.pathname.replace(QR_REDIRECT_PATH, '');

  React.useEffect(() => {
    track('Screen View', {
      screen_name: 'qr_redirect',
      deeplink: locationPath,
    });
  }, [track, locationPath]);

  return (
    <ErrorWrapper>
      <ErrorComponent
        buttonText={continueMessage}
        buttonType="secondary"
        titleText="This content is only available on our mobile app."
        errorTextNode={
          <>
            Scan the QR Code below to open the Exos app on your mobile device,
            or open this link from your mobile device instead. <br />
            <br />
            <QRCode
              value={`https://fit.teamexos.com${locationPath}${location.search}`}
              size={256}
              quietZone={0}
            />
          </>
        }
        onClick={() => {
          track('User Action', {
            event_category: 'error',
            event_location: 'qr_redirect',
            event_name: 'back_button_click',
            deeplink: locationPath,
          });
          navigate(`/`);
        }}
      />
    </ErrorWrapper>
  );
};

export default RedirectQR;
